import { render, staticRenderFns } from "./StatementContent.vue?vue&type=template&id=734bcfaa&scoped=true"
import script from "./StatementContent.vue?vue&type=script&lang=js"
export * from "./StatementContent.vue?vue&type=script&lang=js"
import style0 from "./StatementContent.vue?vue&type=style&index=0&id=734bcfaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734bcfaa",
  null
  
)

export default component.exports